<template>
  <b-form @submit.prevent="submit">
    <header-page-layout
      :page-title="pageTitle"
      :back-to="{ name: 'campaigns-stages', params: { id: $route.params.id } }"
      back-text="Back to Campaign"
    >
      <template slot="actions">
        <b-button variant="outline-primary" type="submit" v-if="!stage.template_id">Save & Select a Template</b-button>
        <b-button variant="outline-primary" type="submit" v-else>Save</b-button>
      </template>

      <b-row>
        <b-col>
          <b-nav tabs>
            <b-nav-item
              exact
              :to="{ name: 'campaigns-edit-stages-edit', params: $route.params }"
              :disabled="$route.name === 'campaigns-edit-stages-create'"
            >
              Details
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'stage-template', params: $route.params }"
              :disabled="$route.name === 'campaigns-edit-stages-create'"
            >
                Template
            </b-nav-item>
          </b-nav>

          <router-view></router-view>
        </b-col>
      </b-row>
    </header-page-layout>
  </b-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderPageLayout from '../components/HeaderPageLayout'
import store from '../store'

export default {
  components: {
    HeaderPageLayout
  },

  async beforeRouteEnter(to, from, next) {
    if ('stageid' in to.params) {
      await store.dispatch('stages/fetchOne', to.params.stageid)
    } else {
      await store.dispatch('stages/newStage', to.params.id)
    }

    next()
  },

  computed: {
    ...mapState('emails', [
      'document'
    ]),

    ...mapState('stages', [
      'stages',
      'stage'
    ]),

    pageTitle() {
      return this.stage._id ? this.stage.name : 'Creating Campaign Stage'
    },

    stageDocument() {
      return this.stage.template_document
    }
  },

  methods: {
    ...mapActions('stages', [
      'fetchOne',
      'saveStage',
      'newStage',
      'updateSubstitution',
      'updateAttribute'
    ]),

    async submit() {
      if (this.document && !this.stage.rawMode) {
        store.commit('updateAttribute', { attribute: 'template_document', value: this.document })
        store.commit('updateAttribute', { attribute: 'template_html', value: this.document.render() })
      }

      const res = await this.saveStage()
      // prevent 'are you sure you want to leave?' prompts
      this.$store.commit('stages/updateStageHasChanges', false)

      const campaignId = this.$route.params.id
      if (this.$route.name === 'campaigns-edit-stages-create') {
        this.$router.push({ name: 'stage-template', params: { id: campaignId, stageid: res._id } })
      } else {
        this.$router.push({ name: 'campaigns-stages', params: { id: campaignId } })
      }
    }
  }
}
</script>
